import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { VehicleOrderRequest } from 'src/app/models/vehicle-order-request.model';
import { VehicleOrderResponse } from 'src/app/models/vehicle-order-response.model';
import { QuoteStatusBadgeType } from 'src/app/helpers/enum/quote-status-badge.enum';
import { VehicleOrderDriverBikPreference } from 'src/app/models/vehicle-order-driver-bik-preference.model';
import { VehicleSpecificationResponse } from 'src/app/models/vehicle-order-specification.model';
import { VehicleConfigurationResponse } from 'src/app/models/vehicle-order-configuration.model';
import { VehicleImageRequest, VehicleImageResponse } from 'src/app/models/vehicle-order-image.model';
import { SKIP_LOADER } from 'src/app/interceptors/auth/http-context-tokens';

@Injectable({
  providedIn: 'root'
})
export class VehicleOrderService {

  constructor(private readonly apiService: ApiService) { }

  getVehicleChoiceList(request: VehicleOrderRequest): Observable<VehicleOrderResponse> {
    return this.apiService.post<VehicleOrderRequest, VehicleOrderResponse>('vehicle-choice-list/search', request);
  }

  getVehicleOrderDriverBikPreference(): Observable<VehicleOrderDriverBikPreference> {
    return this.apiService.get<VehicleOrderDriverBikPreference>('vehicle-order/driver-bik-preference');
  }

  getVehicleSpecification(capId: number): Observable<VehicleSpecificationResponse> {
    return this.apiService.get<VehicleSpecificationResponse>(`vehicle-order/${capId}/specification`);
  }

  getVehicleConfiguration(capId: number): Observable<VehicleConfigurationResponse> {
    return this.apiService.get<VehicleConfigurationResponse>(`vehicle-order/${capId}/vehicle-configuration`);
  }

  getVehicleImage(request: VehicleImageRequest): Observable<VehicleImageResponse> {
    return this.apiService.post<VehicleImageRequest, VehicleImageResponse>('vehicle-order/vehicle-image', request, {
      context: new HttpContext().set(SKIP_LOADER, true)
    });
  }

  saveVehicleOrderDriverBikPreference(request: VehicleOrderDriverBikPreference): Observable<void> {
    return this.apiService.post<VehicleOrderDriverBikPreference, void>('vehicle-order/driver-bik-preference', request);
  }

  // temporary method to fetch the Allowance chip data and the finance data until the API is ready
  getAllowanceDisplayValues(wlcMonthly: number, tradeUpDownMonthly: number, rentalMonthly: number)
    : { allowanceStatus: string; tradeAmount: number; chipClass: string; financeLabel: string; } {
    const maxAllowed = wlcMonthly + tradeUpDownMonthly;

    if (rentalMonthly <= wlcMonthly) {
      return {
        allowanceStatus: QuoteStatusBadgeType.WITHIN_MONTHLY_ALLOWANCE,
        // Temporary workaround: using RentalMonthly for sorting until the Trade Up calculated value source and implementation are finalized.
        tradeAmount: rentalMonthly,
        // tradeAmount: wlcMonthly - rentalMonthly,
        chipClass: 'status-success',
        financeLabel: 'LABEL_UNDER_BUDGET'
      };
    }

    if (rentalMonthly <= maxAllowed) {
      return {
        allowanceStatus: QuoteStatusBadgeType.DRIVER_CONTRIBUTION_REQUIRED,
        // Temporary workaround: using RentalMonthly for sorting until the Trade Up calculated value source and implementation are finalized.
        tradeAmount: rentalMonthly,
        // tradeAmount: rentalMonthly - wlcMonthly,
        chipClass: 'status-warning',
        financeLabel: 'LABEL_DRIVER_CONTRIBUTION'
      };
    }

    return {
      allowanceStatus: QuoteStatusBadgeType.OUTSIDE_FLEET_POLICY,
      // Temporary workaround: using RentalMonthly for sorting until the Trade Up calculated value source and implementation are finalized.
      tradeAmount: rentalMonthly,
      // tradeAmount: rentalMonthly - maxAllowed,
      chipClass: 'status-danger',
      financeLabel: 'LABEL_OVER_BUDGET'
    };
  }
}